<div class="input-group flex-nowrap">
  <span class="input-group-text"><i class="bi bi-lock fw-bold"></i> </span>
  <input [(ngModel)]="localValue" (ngModelChange)="onValueChange($event)" type="password" #psswdFld
    autocomplete="new-password" name="password" class="form-control form-control-lg" placeholder="Enter password">
  <a class="input-group-text"
    (click)="psswdFld.getAttribute('type') === 'password' ? psswdFld.setAttribute('type', 'text') : psswdFld.setAttribute('type', 'password')">
    <i class="bi bi-eye fw-bold text-primary"></i>
  </a>
</div>
